import * as z from "zod";

export const impersonateReferrer = {
  name: "impersonateReferrer" as const,
  input: z.object({
    referrerId: z.string(),
    // Operator's stated reason for impersonating. Stored on the audit row;
    // surfaces in forensics queries. Trimmed and bounded to 500 chars.
    reason: z.string().trim().min(1, "Reason is required").max(500),
  }),
  output: z.object({
    handoffUrl: z.string().url(),
    expiresAt: z.iso.datetime(),
  }),
};
